<template>
  <div class="person-sheet">
    <LoadingSpinner v-if="loading" />
    <main class="" v-if="!loading">
      {{ udpdateHeader("users", selected.user.name) }}
      <div class="contenedor" v-if="selected">
        <div class="contentCenter all">
          <div class="row mt-4">
            <div class="col-12">
              <div>
                <!-- HEADER -->
                <div class="card-top rounded-top">
                  <div
                    v-if="
                      selected.user.client_id != null ||
                      selected.user.role_id != '1'
                    "
                    class="d-flex justify-content-end p-4"
                  >
                    <div class="" v-if="!hasPermissions('isAgencyManager')">
                      <button
                        type="button"
                        id="dropMenuUser"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        class="btn btn-light rounded-pill menu-btn dropdown-toggle"
                      >
                      </button>
                      <div class="dropdown-menu">
                        <form class="px-4 py-3">
                          <div class="form-group mb-2">
                            <label for="modify-credid">Credit</label>
                            <input
                              type="number"
                              min="1"
                              max="500"
                              v-model="amount"
                              class="form-control"
                              id="modify-credit"
                              placeholder="Example: 10.00"
                            />
                          </div>
                          <div class="form-group mb-2">
                            <label for="modify-credid">Select Opportunity</label>
                            <select
                              class="form-control"
                              @click.stop
                              v-model="opportunity"
                            >
                              <option
                                v-for="opp in opportunities"
                                :key="opp.opportunity_id"
                                :value="opp.opportunity_id"
                              >
                                {{ opp.opportunity_tittle }} {{ opp.event_date != '' ? ' - (' + opp.event_date + ')' : '' }}
                              </option>
                            </select>
                          </div>
                      
                        
                          <div class="form-group mb-2">
                            <label for="modify-credid">Reason</label>
                            <select
                              class="form-control"
                              @click.stop
                              v-model="reason"
                            >
                            <option :value="value" v-for="value in reasonCredits">{{ value }}</option>
                           
                            </select>
                          </div>

                          <div class="form-group mb-2">
                            <label for="modify-credid">{{
                              $t("lang.label.description")
                            }}</label>
                            <textarea
                              type="text"
                              class="form-control"
                              v-model="creditDescription"
                              rows="4"
                            >
                            </textarea>
                          </div>
                          <div v-if="error">
                            <small style="color: #dc3545"
                              ><i class="icon-warning"></i> Enter value greater
                              than zero.</small
                            >
                          </div>
                          <button
                            type="button"
                            @click="modifyCredit()"
                            class="btn btn-primary btn-sm mt-2"
                            :disabled="!disabled"
                          >
                            Add
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- MAIN -->
                <div class="col-12">
                  <div class="row">
                    <div class="col-md-2">
                      <div class="wrapper-img-person">
                        <img
                          :src="selected.user.avatar"
                          class="rounded-circle img-profile"
                          alt="person image"
                          v-if="selected.user.avatar"
                        />
                        <img
                          src="@/assets/images/emptyperson.png"
                          class="rounded-circle img-profile ml-5"
                          alt="person image"
                          v-else
                        />
                      </div>
                      <h5 class="ml-3">
                        {{ selected.user.name + " " + selected.user.lastname }}
                      </h5>
                      <hr />
                      <div>
                        <ListOptions
                          v-if="options.length > 0"
                          :options="options"
                          :defaultOption="optionDefault"
                          @optionSelected="optionSelected"
                        />
                      </div>
                      <hr />
                    </div>

                    <!-- CONTENT LIST -->
                    <div class="col-10 my-1">
                      <!-- INFORMACION DEL CONTACTO -->
                      <div class="card p-2 text-center my-1">
                        <div class="row d-flex justify-content-lg-center pt-2">
                          <div class="col-md-12">
                            <Tooltip :text="'User Role'" :width="'130px'">
                              <i class="icon-id-badge text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.user.role_name != null" class="ml-1 mr-2"> {{ selected.user.role_name }} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>

                            <Tooltip :text="'Enterprise'" :width="'130px'">
                              <i class="icon-building-o text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.client.name != null" class="ml-1 mr-2"> {{selected.client.name}} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>

                            <Tooltip :text="'User Creation Date'" :width="'130px'">
                              <i class="icon-sign-in text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.user.creation_date != null" class="ml-1 mr-2"> {{ selected.user.creation_date }} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>

                            <Tooltip :text="'How did you find us?'" :width="'130px'">
                              <i class="fa-solid fa-circle-question text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.user.user_bdr_origin_id != null" class="ml-1 mr-2"> {{ getOrigin(selected.user.user_bdr_origin_id) }} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>
                          </div>
                        </div>
                        <div class="row d-flex justify-content-lg-center pt-2">
                          <div class="col-md-12">
                            <Tooltip :text="'User Email'" :width="'130px'">
                              <i class="icon-mail_outline text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.user.email != null" class="ml-1 mr-2"> {{ selected.user.email }} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>

                            <Tooltip :text="'User Phone'" :width="'130px'">
                              <i class="icon-phone text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.user.phone != null" class="ml-1 mr-2"> {{ selected.user.phone }} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>

                            <Tooltip :text="'User Last Connection Date'" :width="'130px'">
                              <i class="icon-plug text-primary py-0 my-0" style="width: 18px;"></i>
                            </Tooltip>
                            <span v-if="selected.user.last_connection_date != null" class="ml-1 mr-2"> {{ selected.user.last_connection_date }} </span>
                            <span v-else class="ml-1 mr-2 font-weight-bold"> {{ $t("lang.label.not_available") }} </span>
                          </div>
                        </div>
                      </div>
                      <div class="card p-1 mt-3">
                        <!-- GENERAL -->
                        <div
                          class="mx-4 mt-1"
                          v-if="isOptionSelected('general')"
                        >
                          <UserGeneral
                            :selected="selected"
                            :selectedUserId="selectedUserId"
                            @getUser="getUser"
                          >
                          </UserGeneral>
                        </div>

                        <!-- BOOKER WORKING HOURS -->
                        <div
                          class="mx-4 my-1"
                          v-if="isOptionSelected('booker_work_hour')"
                        >
                          <UserBookerWorkingHours
                            :selected="selected"
                            :selectedUserId="selectedUserId"
                            @getUser="getUser"
                          ></UserBookerWorkingHours>
                        </div>

                        <!-- NON WORKING DAYS (Operational / Account Manager) -->
                        <div
                          class="mx-4 my-1"
                          v-if="isOptionSelected('non_working_days')"
                        >
                          <UserNonWorkingDays
                            :selectedUserId="selectedUserId"
                          ></UserNonWorkingDays>
                        </div>

                        <!-- ORDERS -->
                        <div
                          class="mx-2 my-1"
                          v-if="isOptionSelected('orders')"
                        >
                          <OrdersBooker :selected="selected" />
                        </div>

                        <!-- EVALUATIONS -->
                        <div
                          class="mx-2 my-1"
                          v-if="isOptionSelected('evaluations')"
                        >
                          <UserBookerEvaluations :selectedUserId="selectedUserId" />
                        </div>

                        <!-- BOOKER PAYMENT DETAIL -->
                        <div
                          class="mx-4 my-2"
                          v-if="isOptionSelected('booker_payment_detail')"
                        >
                          <UserBookerPaymentDetail
                            :selected="selected"
                            :selectedUserId="selectedUserId"
                            @getUser="getUser"
                          ></UserBookerPaymentDetail>
                        </div>

                        

                        <!-- BOOKER LEADROOM CONFIG -->
                        <div
                          class="m-4"
                          v-if="isOptionSelected('booker_leadroom')"
                        >
                          <UserBookerLeadConfig
                            :selected="selected"
                            :loading="loading"
                            :selectedUserId="selectedUserId"
                            @getUser="getUser"
                          ></UserBookerLeadConfig>
                        </div>

                      <div
                          class="m-4"
                          v-if="isOptionSelected('Booker_task')"
                        >
                       
                          <BdrTasks
                            :user_bdr_id = "selectedUserId"
                            @getUser="getUser"
                          ></BdrTasks>
                          
                         
                        </div>

                        <div
                          class="m-4"
                          v-if="isOptionSelected('test_role_play')"
                        >
                          <BookerTestRolePlay
                            :selected="selected"
                            :loading="true"
                            :selectedUserId="selectedUserId"
                            @getUser="getUser"
                          ></BookerTestRolePlay>
                         
                        </div>

                        <!-- SENDING NOTIFICATIONS -->
                         <div class="mr-4 my-3" v-if="isOptionSelected('emails')">
                            <div class="col-md-12">
                               <select v-model="templateEmail" class="form-control w-50 mb-3">
                                <option :value="81">{{ $t("lang.label.tracking_registration") }}</option>
                                <option :value="82">{{ $t("lang.label.training_mereci_hubert") }}</option>
                                <option :value="83">{{ $t("lang.label.virtual_problem") }}</option>
                               </select>
                              <button class="btn w-50 btn-primary" @click="bookerNotification(selectedUserId, templateEmail)">{{ $t("lang.button.enqueue") }}</button>
                            </div>
                         </div>

                        <!-- CLIENT ROLE CALENDAR -->
                        <div
                          class="m-4"
                          v-if="isOptionSelected('client_role_calendar')"
                        >
                          <div class="col-md-12">
                            <EmailSettings
                              :selectedUserId="selectedUserId"

                            />
                          </div>
                        </div>

                        <!-- CLIENT ROLE DETAILS -->
                        <div
                          class="d-flex flex-column align-items-left"
                          v-if="isOptionSelected('client_role_detail')"
                        >
                          <UserDetailClient
                            :selected="selected"
                            :selectedUserId="selectedUserId"
                            @getUser="getUser"
                          ></UserDetailClient>
                        </div>

                        <!-- CLIENT ROLE BILLING INFO -->
                        <div
                          class="m-4"
                          v-if="isOptionSelected('client_role_billing')"
                        >
                          <div class="col-md-12">
                            <BillingInfo :userId="selected.user.id" />
                          </div>
                        </div>

                        <!-- CHANGE PASSWORD -->
                        <div class="m-4" v-if="isOptionSelected('password')">
                          <div class="col-md-12">
                            <ChangePassword :user_id="selected.user.id" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end contentCenter -->
      </div>
    </main>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { router } from "@/_helpers";
import {
  statusBadgeMixin,
  statusPointMixin,
  pdfInvoiceMixin,
} from "@/_mixins/";
import Header from "@/components/Header.vue";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import {
  usersService,
  clientsService,
  bookersService,
  linksService,
  billingsService,
} from "@/_services";
import BillingInfo from "./BillingInfo.vue";
import UserGeneral from "./UserGeneral.vue";
import UserBookerWorkingHours from "./UserBookerWorkingHours.vue";
import UserNonWorkingDays from "./UserNonWorkingDays.vue";
import UserBookerPaymentDetail from "./UserBookerPaymentDetail.vue";
import OrdersBooker from "./OrdersBooker.vue";
import UserBookerLeadConfig from "./UserBookerLeadConfig.vue";
import UserDetailClient from "./UserDetailClient.vue";
import EmailSettings from "@/components/Account/EmailSettings.vue";
import ChangePassword from "@/components/Account/ChangePassword";
import UserBookerEvaluations from "./UserBookerEvaluations.vue";
import ListOptions from "@/components/Common/ListOptions.vue";
import Treeselect from "@riophae/vue-treeselect";
import Tooltip from "@/components/Common/Tooltip.vue";
import moment from "moment";
import BookerTestRolePlay from "../BDR/BookerTestRolePlay.vue";
import BdrTasks from "../BDR/BdrTasks.vue";

export default {
  mixins: [statusBadgeMixin, statusPointMixin, pdfInvoiceMixin],
  data() {
    return {
      nonWorkingDaysConstraintIds: [1, 2],
      includeRootInNonWorkingDays: true,
      reason:null,
      origin: [
         { id: '1', text: 'lang.label.recommendation' },
         { id: '2', text: 'lang.label.facebook' },
         { id: '3', text: 'lang.label.linkedin' },
         { id: '4', text: 'lang.label.universite_catholique_madagascar' },
         { id: '5', text: 'lang.label.project_pair' },
         { id: '6', text: 'lang.label.other' }         
      ],
    reasonCredits: [
          'Target error',
          'Absent meeting charged (bug)',
          'Absent meeting charged (goodwill gesture)',
          'Prospect not interested',
          'Abusive meeting',
          'Prospect already client',
          'Overbilling',
          'Duplicate meeting',
          'Google review'
        ],
      selected: null,
      loading: true,
      isClientBooker: false,
      options: [],
      optionsBooker: [],
      optionDefault: 1,
      daysNonWorking: [],
      opportunities: [],
      opportunity: null,
      target: null,
      amount: 1,
      creditDescription: null,
      meeting_price: 1,
      group_role: 1,
      group: false,
      groupnew: "",
      error: false,
      model_status_date: null,
      model_commission_meeting: "",
      templateEmail: null,
      validWithSuperior: false,
    };
  },
  props: {
    selectedUserId: String,
  },

  components: {
    Header,
    LoadingSpinner,
    BillingInfo,
    EmailSettings,
    ChangePassword,
    Treeselect,
    ListOptions,
    UserGeneral,
    UserBookerPaymentDetail,
    UserBookerLeadConfig,
    UserDetailClient,
    UserBookerWorkingHours,
    UserNonWorkingDays,
    OrdersBooker,
    Tooltip,
    UserBookerEvaluations,
    BookerTestRolePlay,
    BdrTasks
  },
  watch: {
    Page() {
      this.$route.fullPath == "/users"
        ? this.changeHeaderTab({ tab: "ALL" })
        : "";
      return;
    },
  },
  computed: {
    ...mapState({
      // loading: (state) => state.users.loading,
      currentUser: (state) => state.authentication.user,
    }),
    ...mapState({
      headerTab: (state) => state.header.tab,
    }),
    disabled: function () {
      if (this.amount != "" && this.amount > 0 && this.amount <= 500) {
        return true;
      }
    },
    user() {
      return this.$store.state.authentication.user;
    },
    Page() {
      this.$route.fullPath == "/users"
        ? this.changeHeaderTab({ tab: "ALL" })
        : "";
      return;
    },
    isOptionSelected() {
      return (value) => {
        const idOptionSelected = this.options.find(
          (el) => el.selected == true && el.name === value
        );
        if (idOptionSelected) {
          return idOptionSelected.name === value ? true : false;
        } else {
          return false;
        }
      };
    },
    getOrigin() {
      return (id) => {
        let originSelected = this.origin.find((el) => el.id === id);
        if (originSelected) {
          return this.$t(originSelected.text);
        } else {
          return this.$t("lang.label.not_available");
        }
      };
    },
  },
  async mounted() {
    await this.getUser(); // NECESITO ASINCRONIA PARA PODER ESPERAR LA RESPUESTA DE API Y DETERMINAR QUE TIPO DE CLIENTE CONTIENE EL USER

    if (!this.isClientBooker) {
      this.options = [
        {
          id: 1,
          name: "client_role_detail",
          label: "General",
          selected: false,
          hasPermission: true,
        },
        {
          id: 7,
          name: "client_role_calendar",
          label: "Client Role Calendar",
          selected: false,
          hasPermission: true,
        },
        {
          id: 9,
          name: "client_role_billing",
          label: "Client Role Billing Info",
          selected: false,
          hasPermission: true,
        },
        {
          id: 10,
          name: "password",
          label: "Password",
          selected: false,
          hasPermission: true,
        },
      ];

      if (this.isNonWorkingDaysInternalUser(this.selected.user)) {
        this.options.splice(this.options.length - 1, 0, {
          id: 11,
          name: "non_working_days",
          label: "Non working days",
          selected: false,
          hasPermission: this.hasPermissions("superAdmin"),
        });
      }
    }else{
      this.options = [ // OPCIONES DE TABS PARA BOOKERS
         {
          id: 1,
          name: "general",
          label: "General",
          selected: false,
          hasPermission: true,
        },
        {
          id: 2,
          name: "booker_work_hour",
          label: "Booker Working Hours",
          selected: false,
          hasPermission: true,
        },
        {
          id: 3,
          name: "orders",
          label: this.$t("lang.orders.orders"),
          selected: false,
          hasPermission: true,
        },
        {
          id: 4,
          name: "evaluations",
          label: "Evaluations",
          selected: false,
          hasPermission: true,
        },
        {
          id: 5,
          name: "booker_payment_detail",
          label: "Booker Payment Detail",
          selected: false,
          hasPermission: true,
        },
        {
          id: 6,
          name: "booker_leadroom",
          label: "Booker Leadroom Config",
          selected: false,
          hasPermission: true,
        },
        {
          id: 7,
          name: "Booker_task",
          label: "Booker task",
          selected: false,
          hasPermission: true,
        },
           {
          id: 8,
          name: "test_role_play",
          label: "Test role play",
          selected: false,
          hasPermission: true,
        },
        {
          id: 9,
          name: "emails",
          label: "Sending Notifications",
          selected: false,
          hasPermission: true,
        },
        {
          id: 10,
          name: "password",
          label: "Password",
          selected: false,
          hasPermission: true,
        },
      ];
    }
    if (this.selected.user.role_id == 4){
      this.GetOppsByClient(this.selected.user.client_id);
    }
  },

  methods: {
    ...mapActions("header", {
      changeHeaderTab: "changeTab",
    }),
    ...mapActions("headertopbar", {
      setCurrentRoute: "setRoute",
      setCurrentRouteChild: "setRouteChild",
    }),
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },

    isNonWorkingDaysInternalUser(user) {
      if (!user) return false;
      const roleId = String(user.role_id);

      if (roleId.includes("-")) {
        const [role, constraint] = roleId.split("-").map((v) => parseInt(v, 10));
        return role === 1 && this.nonWorkingDaysConstraintIds.includes(constraint);
      }

      if (parseInt(user.role_id, 10) !== 1) {
        return false;
      }

      // Root: no user_constraint_id 
      if (
        user.user_constraint_id === undefined ||
        user.user_constraint_id === null ||
        user.user_constraint_id === ""
      ) {
        return this.includeRootInNonWorkingDays;
      }

      return this.nonWorkingDaysConstraintIds.includes(
        parseInt(user.user_constraint_id, 10)
      );
    },

    GetOppsByClient(client_id){
      linksService.getOpportunitiesByClient(client_id)
      .then((res) =>{
        this.opportunities = [
          {
            opportunity_id: 0,
            opportunity_tittle: '-',
            event_date: ''
          },
          ...res
        ];
      })
      .catch((error) => {
        console.log(error)
      });
    },

    bookerNotification(user_id, template_id){
      bookersService
      .queueBookerNotification(user_id, template_id)
      .then((res) =>{
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.enqueuered_success"),
              showConfirmButton: false,
              timer: 3500,
            });
      })
      .catch((error) => {
        console.log(error.result)
        if(error.result == 'Not Found: Template'){
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.general.template_not_found"),
            showConfirmButton: true
          });
        }else if(error.result == 'Not Found: Token'){
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.general.tokens_not_found"),
            showConfirmButton: true
          });
        }else{
          this.$swal({
            type: "warning",
            title: this.$t("lang.label.error"),
            html: this.$t("lang.general.error"),
            showConfirmButton: true
          });
        }
      });
    },

    optionSelected(option) {
      this.options.forEach((e) => (e.selected = false));
      this.options.find((el) => el.id === option).selected = true;
    },
    udpdateHeader(route, currentChild) {
      this.setCurrentRoute({ page: route });
      this.setCurrentRouteChild({ child: currentChild });
    },
    refreshCredit() {
      this.getUser();
    },
    async getTotalCredits(client_id, amount) {
      try {
        const res = await billingsService.getTotalCreditsByClient(client_id, amount);
        this.validWithSuperior = res.valid_with_superior == 1;
        return res;
      } catch (error) {
        console.log(error);
        this.validWithSuperior = false;
        return null;
      }
    },
    async modifyCredit() {
      this.opportunity = this.opportunity == 0 ? null : this.opportunity; 

      if(this.reason == null || this.reason == '' || this.creditDescription == null || this.creditDescription == '' || this.amount <= 0){
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.error"),
          text: "One or more fields are missing",
          showConfirmButton: true
        });
        return;
      }

      this.validWithSuperior = false;
      await this.getTotalCredits(this.selected.user.client_id, this.amount);
      if (this.validWithSuperior == true) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.error"),
          text: this.$t("lang.credits.warning"),
          showConfirmButton: true,
        });
        return;
      }

      if (this.amount > 0 && this.validWithSuperior == false) {
        this.$swal({
          type: "warning",
          title: this.$t("lang.label.areyousure"),
          text: "Modify Credit",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33a2c",
          confirmButtonText: this.$t("lang.button.yes"),
          cancelButtonText: this.$t("lang.button.cancel"),
        }).then((result) => {
          if (result.value) {
            clientsService
              .modifyCredit(
                this.selectedUserId,
                this.amount,
                this.creditDescription,
                this.opportunity,
                this.reason
              )
              .then((response) => {
                this.$swal({
                  type: "success",
                  title: this.$t("lang.label.great"),
                  text: "Credit modified successfully",
                  showConfirmButton: false,
                  timer: 3000,
                });
              })
              .then((response) => {
                this.refreshCredit();
                this.amount = 1;
                this.creditDescription = null;
                this.reason = null;
              })
              .catch((err) => {
                if(err == 'The credit for this opportunity already exists.'){
                  this.$swal({
                    type: "error",
                    title: this.$t("lang.label.error"),
                    text: "Cannot add credit for this opportunity because already exists another credit here.",
                    showConfirmButton: true,
                  });
                }
              });
          }
        });
      } else {
        this.error === true;
      }
    },
    async getUser() {
      this.loading = true;
      try {
        const response = await usersService.getUserById(this.selectedUserId);
        this.selected = response;
        if (this.selected.user.client_id == 2873) {
          this.isClientBooker = true;
        }
      } finally {
        this.loading = false;
      }
    },
    changeTab(selectedTab) {
      this.changeHeaderTab({ tab: selectedTab });
    },
    // goToCampaign(campaign_id, campaign_name) {
    //   this.changeHeaderTab({ tab: "STATS" });
    //   router.push({
    //     name: "campaigns",
    //     params: { id: campaign_id.toString(), name: campaign_name.toString() },
    //   });
    // },
  },
};
</script>
<style>
#dropMenuUser.btn-light {
  border-color: transparent;
  background-color: transparent;
  outline: none !important;
}

#dropMenuUser.btn-light.menu-btn {
  width: 20px;
  height: 25px;
}

#dropMenuUser.btn-light.focus,
#dropMenuUser.btn-light:focus {
  box-shadow: none !important;
}

#dropMenuUser.btn-light.menu-btn small {
  position: absolute;
  top: 3px;
  left: 10px;
}

#dropMenuUser.btn-light.menu-btn small i {
  color: #ffffff;
  font-size: 18px;
}
</style>
